// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3026":"f6ffe45f","5435":"6fc210c2"}[chunkId] + ".chunk.css";
};